const Pill = () => {
  return (
    <svg
      aria-hidden="true"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.52373 4.7432L2.22939 7.03754C1.6023 7.66463 1.25 8.51515 1.25 9.40199C1.25 10.2888 1.6023 11.1393 2.22939 11.7664C2.85648 12.3935 3.707 12.7458 4.59384 12.7458C5.48068 12.7458 6.3312 12.3935 6.95829 11.7664L9.25263 9.47211L4.52373 4.7432ZM9.402 0C8.18364 0 7.01518 0.483993 6.15366 1.3455L1.34551 6.15366C0.483993 7.01517 0 8.18363 0 9.40199C0 10.6203 0.483992 11.7888 1.34551 12.6503C2.20702 13.5118 3.37548 13.9958 4.59384 13.9958C5.8122 13.9958 6.98066 13.5118 7.84218 12.6503L12.6503 7.84218C13.5118 6.98067 13.9958 5.8122 13.9958 4.59383C13.9958 3.37547 13.5118 2.20701 12.6503 1.3455C11.7888 0.483993 10.6203 0 9.402 0Z"
        fill="white"
      />
    </svg>
  )
}

export default Pill
